module.exports = __webpack_public_path__ + "img/TECHNOLOGY-BALENO-3.6d11da53.jpg";